<template>
  <div></div>
</template>
<script>
export default {
  // Don't delete this component
  // See routing in main.js
  mounted() {
    // Prerendering
    // https://github.com/chrisvfritz/prerender-spa-plugin
    document.dispatchEvent(new Event("page-rendered"));
  }
};
</script>